"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArenaClient = exports.HttpError = void 0;
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(message, status) {
        if (status === void 0) { status = 500; }
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.name = 'HttpError';
        return _this;
    }
    return HttpError;
}(Error));
exports.HttpError = HttpError;
var ArenaClient = /** @class */ (function () {
    function ArenaClient(config) {
        this.domain = 'https://api.are.na/v2/';
        this.headers = {
            'Content-Type': 'application/json',
            Authorization: (config === null || config === void 0 ? void 0 : config.token) ? "Bearer ".concat(config.token) : '',
        };
        this.fetch = (config === null || config === void 0 ? void 0 : config.fetch) || (window === null || window === void 0 ? void 0 : window.fetch.bind(window));
        this.date = (config === null || config === void 0 ? void 0 : config.date) || Date;
    }
    ArenaClient.prototype.me = function () {
        return this.getJson('me');
    };
    ArenaClient.prototype.channels = function (options) {
        return this.getJsonWithPaginationQuery('channels', options);
    };
    ArenaClient.prototype.user = function (id) {
        var _this = this;
        return {
            get: function () { return _this.getJson("users/".concat(id)); },
            channels: function (options) {
                return _this.getJsonWithPaginationQuery("users/".concat(id, "/channels"), options);
            },
            following: function () {
                return _this.getJson("users/".concat(id, "/following"));
            },
            followers: function () {
                return _this.getJson("users/".concat(id, "/followers"));
            },
        };
    };
    ArenaClient.prototype.group = function (slug) {
        var _this = this;
        return {
            get: function () { return _this.getJson("groups/".concat(slug)); },
            channels: function (options) {
                return _this.getJsonWithPaginationQuery("groups/".concat(slug, "/channels"), options);
            },
        };
    };
    ArenaClient.prototype.channel = function (slug) {
        var _this = this;
        return {
            sort: {
                block: function (id, position) {
                    return _this.sortConnection(slug, id, position, 'Block');
                },
                channel: function (id, position) {
                    return _this.sortConnection(slug, id, position, 'Channel');
                },
            },
            connect: {
                block: function (blockId) {
                    return _this.createConnection(slug, blockId, 'Block');
                },
                channel: function (channelId) {
                    return _this.createConnection(slug, channelId, 'Channel');
                },
            },
            disconnect: {
                block: function (blockId) {
                    // 204 on success
                    return _this.del("channels/".concat(slug, "/blocks/").concat(blockId));
                },
                connection: function (connectionId) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, this.del("connections/".concat(connectionId))];
                }); }); },
            },
            contents: function (options) {
                return _this.getJsonWithPaginationQuery("channels/".concat(slug, "/contents"), options);
            },
            connections: function (options) {
                return _this.getJsonWithPaginationQuery("channels/".concat(slug, "/connections"), options);
            },
            create: function (status) {
                return _this.postJson('channels', {
                    title: slug,
                    status: status,
                });
            },
            update: function (data) {
                return _this.putJson("channels/".concat(slug), data);
            },
            createBlock: function (data) {
                return _this.postJson("channels/".concat(slug, "/blocks"), data);
            },
            get: function (options) {
                return _this.getJsonWithPaginationQuery("channels/".concat(slug), options);
            },
            delete: function () {
                return _this.del("channels/".concat(slug));
            },
            thumb: function () {
                return _this.getJson("channels/".concat(slug, "/thumb"));
            },
        };
    };
    ArenaClient.prototype.block = function (id) {
        var _this = this;
        return {
            channels: function (options) {
                return _this.getJsonWithPaginationQuery("blocks/".concat(id, "/channels"), options);
            },
            get: function () {
                return _this.getJson("blocks/".concat(id));
            },
            update: function (data) {
                return _this.putJson("blocks/".concat(id), data);
            },
            comments: function (options) {
                return _this.getJsonWithPaginationQuery("blocks/".concat(id, "/comments"), options);
            },
            addComment: function (body) {
                return _this.postJson("blocks/".concat(id, "/comments"), { body: body });
            },
            deleteComment: function (commentId) {
                return _this.del("blocks/".concat(id, "/comments/").concat(commentId));
            },
            updateComment: function (commentId, body) {
                return _this.putJson("blocks/".concat(id, "/comments/").concat(commentId), { body: body });
            },
        };
    };
    Object.defineProperty(ArenaClient.prototype, "search", {
        get: function () {
            var _this = this;
            return {
                everything: function (query, options) {
                    return _this.getJsonWithSearchAndPaginationQuery("/search", __assign({ q: query }, options));
                },
                blocks: function (query, options) {
                    return _this.getJsonWithSearchAndPaginationQuery("/search/blocks", __assign({ q: query }, options));
                },
                channels: function (query, options) {
                    return _this.getJsonWithSearchAndPaginationQuery("/search/channels", __assign({ q: query }, options));
                },
                users: function (query, options) {
                    return _this.getJsonWithSearchAndPaginationQuery("/search/users", __assign({ q: query }, options));
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    ArenaClient.prototype.createConnection = function (channelSlug, id, type) {
        return this.postJson("channels/".concat(channelSlug, "/connections"), {
            connectable_type: type,
            connectable_id: id,
        });
    };
    ArenaClient.prototype.sortConnection = function (channelSlug, id, position, type) {
        return this.putJson("channels/".concat(channelSlug, "/sort"), {
            connectable_type: type,
            connectable_id: id,
            new_position: position,
        });
    };
    ArenaClient.prototype.getJsonWithSearchAndPaginationQuery = function (url, options) {
        var qs = this.paginationQueryString(options);
        var searchQuery = options && options.q ? "q=".concat(options.q).concat(qs ? '&' : '') : '';
        return this.getJson("".concat(url, "?").concat(searchQuery).concat(qs));
    };
    ArenaClient.prototype.getJsonWithPaginationQuery = function (url, options) {
        var qs = this.paginationQueryString(options);
        return this.getJson("".concat(url, "?").concat(qs));
    };
    ArenaClient.prototype.getJson = function (endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch("".concat(this.domain).concat(endpoint), {
                        method: 'GET',
                        headers: this.headers,
                    }).then(function (res) {
                        if (res.ok) {
                            return res.json();
                        }
                        throw new HttpError(res.statusText, res.status);
                    })];
            });
        });
    };
    ArenaClient.prototype.putJson = function (endpoint, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch("".concat(this.domain).concat(endpoint), {
                        method: 'PUT',
                        headers: this.headers,
                        body: data ? JSON.stringify(data) : undefined,
                    }).then(function (res) {
                        if (res.ok) {
                            return undefined;
                        }
                        throw new HttpError(res.statusText, res.status);
                    })];
            });
        });
    };
    ArenaClient.prototype.postJson = function (endpoint, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch("".concat(this.domain).concat(endpoint), {
                        method: 'POST',
                        headers: this.headers,
                        body: data ? JSON.stringify(data) : undefined,
                    }).then(function (res) {
                        if (res.ok) {
                            return res.json();
                        }
                        throw new HttpError(res.statusText, res.status);
                    })];
            });
        });
    };
    ArenaClient.prototype.del = function (endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch("".concat(this.domain).concat(endpoint), {
                        method: 'DELETE',
                        headers: this.headers,
                    }).then(function (res) {
                        if (res.ok) {
                            return undefined;
                        }
                        throw new HttpError(res.statusText, res.status);
                    })];
            });
        });
    };
    ArenaClient.prototype.paginationQueryString = function (options) {
        var _a = __assign(__assign({}, ArenaClient.defaultPaginationOptions), options), page = _a.page, per = _a.per, sort = _a.sort, direction = _a.direction, forceRefresh = _a.forceRefresh;
        var attrs = [];
        if (page)
            attrs.push("page=".concat(page));
        if (per)
            attrs.push("per=".concat(per));
        if (sort)
            attrs.push("sort=".concat(sort));
        if (direction)
            attrs.push("direction=".concat(direction));
        if (forceRefresh)
            attrs.push("date=".concat(this.date.now()));
        return attrs.join('&');
    };
    ArenaClient.defaultPaginationOptions = {
        sort: 'position',
        direction: 'desc',
        per: 50,
    };
    return ArenaClient;
}());
exports.ArenaClient = ArenaClient;
//# sourceMappingURL=arena_service.js.map